
import { motion } from "framer-motion"
import { Transitions } from "../transitions/pageTransitions"

export const Jukebox = ()=>{

    return(
        <motion.div className='absolute' style={{ height:'100%', width:'100%', overflow:'scroll' }}
            initial="initial"
            animate="in"
            exit="out"
            variants={Transitions.pageVariants}
            transition={Transitions.pageTransition}
        >
            <div className="flex-column center-both " >
                <div>Jukebox</div>
            </div>
        
        </motion.div>
    )
}